import Vue from 'vue'
import Vuex from 'vuex'
import UserModule from './module/user'
import SettingModule from './module/setting'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    UserModule,
    SettingModule
  },
  plugins: [createPersistedState()]
})
